import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { DashboardObjetivosService, Objetivo, ObjetivoSalvar, ObjetivosLista } from '../../../core/services/dashboard/resultados/dashboard-objetivos.service';

@Component({
  selector: 'app-dashboard-objetivos', standalone: true, imports: [CommonModule, FormsModule],
  templateUrl: './dashboard-objetivos.component.html', styleUrls: ['./dashboard-objetivos.component.css']
})
export class DashboardObjetivosComponent implements OnInit, OnDestroy {
  inicio = this.data(new Date(new Date().getFullYear(), new Date().getMonth(), 1));
  fim = this.data(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0));
  sellerId: number | null = null;
  situacao = '';
  lista: ObjetivosLista = { podeGerenciar: false, vendedores: [], objetivos: [] };
  carregando = false;
  salvando = false;
  erro = '';
  erroEdicao = '';
  mensagem = '';
  edicao: ObjetivoSalvar | null = null;
  edicaoId: number | null = null;
  confirmarDesativacao: Objetivo | null = null;
  private leitura?: Subscription;
  private escrita?: Subscription;
  constructor(private service: DashboardObjetivosService) {}
  ngOnInit() { this.carregar(); }
  ngOnDestroy() { this.leitura?.unsubscribe(); this.escrita?.unsubscribe(); }
  get objetivos() { return this.lista.objetivos.filter(o => !this.situacao || o.situacao === this.situacao); }
  carregar() {
    if (!this.inicio || !this.fim || this.inicio > this.fim) { this.erro = 'Informe um intervalo de vigência válido.'; return; }
    this.leitura?.unsubscribe(); this.carregando = true; this.erro = '';
    this.leitura = this.service.listar(this.inicio, this.fim, this.sellerId).subscribe({
      next: lista => { this.lista = lista; this.carregando = false; },
      error: erro => {
        this.erro = this.erroApi(erro); this.carregando = false;
        this.lista.objetivos = [];
        if (erro.status === 401 || erro.status === 403) this.lista.podeGerenciar = false;
      }
    });
  }
  novo() {
    this.edicaoId = null; this.erroEdicao = ''; this.mensagem = ''; this.confirmarDesativacao = null;
    this.edicao = { sellerId: this.sellerId, nome: '', dataInicial: this.inicio, dataFinal: this.fim,
      objetivo: null, premiacaoValor: null, premiacaoDescricao: '' };
  }
  editar(item: Objetivo) {
    if (!this.lista.podeGerenciar || this.salvando) return;
    this.edicaoId = item.id; this.erroEdicao = ''; this.mensagem = ''; this.confirmarDesativacao = null;
    this.edicao = { sellerId: item.sellerId, nome: item.nome, dataInicial: item.dataInicial.slice(0, 10),
      dataFinal: item.dataFinal.slice(0, 10), objetivo: item.objetivo, premiacaoValor: item.premiacaoValor,
      premiacaoDescricao: item.premiacaoDescricao || '', versao: item.versao };
  }
  cancelar() { if (!this.salvando) { this.edicao = null; this.erroEdicao = ''; } }
  salvar() {
    const d = this.edicao;
    if (!d || this.salvando) return;
    if (!d.sellerId || !d.nome.trim() || !d.dataInicial || !d.dataFinal || d.dataInicial > d.dataFinal ||
        d.objetivo == null || d.objetivo < 0 || (d.premiacaoValor != null && d.premiacaoValor < 0)) {
      this.erroEdicao = 'Preencha vendedor, nome, período e objetivo com valores válidos.'; return;
    }
    this.salvando = true; this.erroEdicao = '';
    const novo = this.edicaoId == null;
    this.escrita = this.service.salvar(this.edicaoId, { ...d, nome: d.nome.trim() }).subscribe({
      next: () => {
        this.salvando = false; this.edicao = null;
        this.mensagem = novo ? 'Objetivo criado. O cálculo aguarda configuração pela Napis.' : 'Objetivo atualizado.';
        this.carregar();
      },
      error: erro => { this.salvando = false; this.erroEdicao = this.erroApi(erro); }
    });
  }
  desativar() {
    if (!this.confirmarDesativacao || this.salvando) return;
    this.salvando = true;
    this.escrita = this.service.desativar(this.confirmarDesativacao).subscribe({
      next: () => { this.salvando = false; this.confirmarDesativacao = null; this.edicao = null; this.mensagem = 'Objetivo desativado.'; this.carregar(); },
      error: erro => { this.salvando = false; this.erro = this.erroApi(erro); }
    });
  }
  barra(percentual: number | null) { return Math.max(0, Math.min(100, percentual || 0)); }
  private data(d: Date) { return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`; }
  private erroApi(erro: any): string {
    if (erro.status === 401) return 'Entre novamente no portal para acessar os objetivos.';
    return erro.error?.mensagem || 'Não foi possível concluir a operação. Tente novamente ou contate o suporte.';
  }
}
